import { EditorAttachmentsAction } from "./EditorAttachmentsAction";
export default EditorAttachmentsAction;
export * from "./EditorAttachmentsAction";
